import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { stringToNumber } from '@utils/number'

export const paramsToObject = (params: URLSearchParams) => {
	const entries = params.entries()
	const result: any = {}
	for (const [key, value] of entries) {
		result[key] = stringToNumber(value, value)
	}
	return result
}

const useQuery = () => {
	const { search } = useLocation()

	return useMemo(() => new URLSearchParams(search), [search])
}

export default useQuery
